import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "../HomePage.css";
import { activeManagers } from "../managersData";

const chrisBode = activeManagers.find(m => m.manager === "Chris Bode");

const navItems = [
    { label: "Home", path: "/" },
    { label: "Managers", path: "/managers" },
    { label: "Seasons", path: "/seasons" },
    { label: "League Settings", path: "/league-settings" },
];

const matchups2023 = [
    { opponent: "Cowboys D Week 11", pointsFor: 139.25, pointsAgainst: 166.85 },
    { opponent: "Makin me Christian", pointsFor: 112.5, pointsAgainst: 163.85 },
    { opponent: "MaverNick", pointsFor: 140.55, pointsAgainst: 183.6 },
    { opponent: "FAFO", pointsFor: 144.5, pointsAgainst: 231.25 },
    { opponent: "hot girl dream team", pointsFor: 179.3, pointsAgainst: 154.15 },
    { opponent: "Team Ireland", pointsFor: 141.9, pointsAgainst: 149.0 },
    { opponent: "Wagon Wheel", pointsFor: 122.5, pointsAgainst: 124.55 },
    { opponent: "Cowboys D Week 11", pointsFor: 196.9, pointsAgainst: 145.75 },
    { opponent: "Makin me Christian", pointsFor: 122.3, pointsAgainst: 142.55 },

    { opponent: "MaverNick", pointsFor: 145.65, pointsAgainst: 134.45 },
    { opponent: "FAFO", pointsFor: 88.55, pointsAgainst: 117.55 },
    { opponent: "hot girl dream team", pointsFor: 168.2, pointsAgainst: 176.5 },
    { opponent: "Team Ireland", pointsFor: 186.4, pointsAgainst: 69.0 },
    { opponent: "Wagon Wheel", pointsFor: 139.25, pointsAgainst: 104.8 },
    { opponent: "Placeholder", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "Placeholder", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "Placeholder", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "Placeholder", pointsFor: 0, pointsAgainst: 0 },
];
const matchups2024 = [
    { opponent: "Ariza's Army", pointsFor: 149.9, pointsAgainst: 130.75 },
    { opponent: "FAFO", pointsFor: 145.25, pointsAgainst: 178.75 },
    { opponent: "Rashad's Fentmaxxers", pointsFor: 138.85, pointsAgainst: 107.05 },
    { opponent: "Dave's Duds", pointsFor: 122.15, pointsAgainst: 171.85 },
    { opponent: "Run it Back", pointsFor: 140.6, pointsAgainst: 108.05 },
    { opponent: "Beats by Ray", pointsFor: 88.9, pointsAgainst:  83.65},
    { opponent: "Four Loko Army", pointsFor: 149.9, pointsAgainst: 116.1 },
    { opponent: "Maverick", pointsFor: 171.4, pointsAgainst: 121.25 },
    { opponent: "The Decision Makers", pointsFor: 145.55, pointsAgainst: 121.55 },

    { opponent: "Ariza's Army", pointsFor: 122.25, pointsAgainst: 107.6 },
    { opponent: "FAFO", pointsFor: 118.35, pointsAgainst: 105.4 },
    { opponent: "Rashad's Fentmaxxers", pointsFor: 146.6, pointsAgainst: 136.6 },
    { opponent: "Dave's Duds", pointsFor: 116.65, pointsAgainst: 167.7 },
    { opponent: "Run it Back", pointsFor: 157.95, pointsAgainst: 138.8 },
    { opponent: "TBD", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "TBD", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "TBD", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "TBD", pointsFor: 0, pointsAgainst: 0 },
];

const ChrisBode = () => {
    return (
        <div className="homepage-container">
            {/* Header */}
            <header className="header">
                <nav className="nav-bar">
                    {navItems.map(({ label, path }, i) => (
                        <Link key={i} to={path} className="nav-link" tabIndex={0}>
                            {label}
                        </Link>
                    ))}
                </nav>
            </header>

            {/* Title */}
            <motion.h1
                className="footballin-title"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.1, duration: 0.6 }}
            >
                Chris Bode — RIP rashee
            </motion.h1>

            {/* Side-by-side cards */}
            <main
                className="main-content"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2rem",
                    justifyContent: "center",
                    width: "75%",
                    margin: "2rem auto",
                }}
            >
                {/* Top two sections: About & Notable Stats */}
                <div style={{ display: "flex", gap: "2rem" }}>
                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                    >
                        <h2 className="section-title">📘 About</h2>
                        <p>
                            Manager of the team <strong>RIP rashee</strong>.<br />
                            Alternate Names: <em>i lied, Kyle Pitts Sucks</em>
                        </p>
                    </motion.section>

                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.5 }}
                    >
                        <h2 className="section-title">📊 Notable Stats</h2>
                        <p>
                            <strong>Overall Record:</strong> 16-12-0<br />
                            <strong>Championship Record:</strong> 0-1<br />
                            <strong>2023–2024:</strong> 5-9-0<br />
                            <strong>2024–2025:</strong> 11-3-0<br />
                            <strong>2025–2026:</strong> 0-0-0
                        </p>
                    </motion.section>
                </div>

                {/* New section: 2023-2024 Season header */}
                <h2 className="section-title" style={{ textAlign: "center", marginTop: "2rem" }}>
                    2023-2024 Season
                </h2>

                {/* Season two side-by-side sections */}
                <div style={{ display: "flex", gap: "2rem" }}>
                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 0.5 }}
                    >
                        <h2 className="section-title">📝 Draft Picks</h2>
                        {chrisBode.draftPicks[2023].length ? (
                            <ul>
                                {chrisBode.draftPicks[2023].map((pick, idx) => (
                                    <li key={idx}>
                                        Round {pick.round} - Pick {pick.pick} - {pick.player} - {pick.team}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No draft picks recorded for 2023.</p>
                        )}
                    </motion.section>

                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5, duration: 0.5 }}
                    >
                        <h2 className="section-title">📈 Team & Stats</h2>

                        <div className="team-stats">
                            <p><strong>Rank:</strong> #6</p>
                            <p><strong>Season Record:</strong> 5-9-0</p>
                            <p><strong>Points for: </strong>2027.75</p>
                            <p><strong>Points against: </strong>2063.85</p>
                            <p><strong>Average PPG: </strong>144.8</p>
                            <p><strong>Average Opponent PPG: </strong>147.4</p>
                            <p><strong>Team moves: </strong>36</p>
                        </div>

                        <hr style={{ margin: '1.5rem 0' }} />

                        <div className="ending-team">
                            <h3>Ending Team</h3>
                            <p><strong>QB:</strong> Justin Fields</p>
                            <p>
                                <strong>RB:</strong> Alvin Kamara, Kyren Williams, Bijan Robinson, Jahmyr Gibbs, Kenneth Walker III, De'Von Achae, Zach Charbonnet
                            </p>
                            <p>
                                <strong>WR:</strong> Ja'Marr Chase, Garrett Wilson, Calvin Ridley, Jaylen Waddle, Zay Flowers, Terry McLaurin
                            </p>
                            <p>
                                <strong>TE:</strong> Sam LaPorta, Trey McBride, Dalton Kincaid
                            </p>
                            <p><strong>D/ST:</strong> Dolphins</p>
                            <p><strong>K:</strong> Matt Gay</p>
                        </div>
                    </motion.section>
                </div>

                {/* Matchup grid below draft picks and team & stats */}
                <motion.section
                    className="matchup-grid card"
                    style={{ marginTop: "2rem", padding: "1rem" }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.5 }}
                >
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(9, 1fr)",  // 9 columns equal width
                            gridAutoRows: "auto",
                            gap: "0.5rem",
                            width: "100%", // full width of parent container
                        }}
                    >
                        {matchups2023.map(({ opponent, pointsFor, pointsAgainst }, index) => {
                            const won = pointsFor > pointsAgainst;
                            const weekNumber = index + 1; // week number 1-18
                            return (
                                <div
                                    key={index}
                                    style={{
                                        backgroundColor: won ? "#d4edda" : "#f8d7da",
                                        border: `1px solid ${won ? "#155724" : "#721c24"}`,
                                        borderRadius: "6px",
                                        padding: "0.5rem",
                                        fontSize: "0.8rem",
                                        textAlign: "center",
                                        color: won ? "#155724" : "#721c24",
                                        userSelect: "none",
                                        minWidth: 0,
                                    }}
                                >
                                    <div>Week {weekNumber}:</div>
                                    <div>vs. {opponent}</div>
                                    <div>
                                        {pointsFor} - {pointsAgainst}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </motion.section>

                

                {/* New section: 2023-2024 Season header */}
                <h2 className="section-title" style={{ textAlign: "center", marginTop: "2rem" }}>
                    2024-2025 Season
                </h2>

                {/* Season two side-by-side sections */}
                <div style={{ display: "flex", gap: "2rem" }}>
                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 0.5 }}
                    >
                        <h2 className="section-title">📝 Draft Picks</h2>
                        {chrisBode.draftPicks[2024].length ? (
                            <ul>
                                {chrisBode.draftPicks[2024].map((pick, idx) => (
                                    <li key={idx}>
                                        Round {pick.round} - Pick {pick.pick} - {pick.player} - {pick.team}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No draft picks recorded for 2023.</p>
                        )}
                    </motion.section>

                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5, duration: 0.5 }}
                    >
                        <h2 className="section-title">📈 Team & Stats</h2>

                        <div className="team-stats">
                            <p><strong>Rank:</strong> #2</p>
                            <p><strong>Season Record:</strong> 11-3-0</p>
                            <p><strong>Points for: </strong>1914.3</p>
                            <p><strong>Points against: </strong>1795.1</p>
                            <p><strong>Average PPG: </strong>136.7</p>
                            <p><strong>Average Opponent PPG: </strong>128.2</p>
                            <p><strong>Team moves: </strong>62</p>
                        </div>

                        <hr style={{ margin: '1.5rem 0' }} />

                        <div className="ending-team">
                            <h3>Ending Team</h3>
                            <p><strong>QB:</strong> Jared Goff, Brock Purdy</p>
                            <p>
                                <strong>RB:</strong> Jahmyr Gibbs, De'Von Achane, Alexander Mattison
                            </p>
                            <p>
                                <strong>WR:</strong> Adam Thielen, Jalen McMillan, Malik Nabers, CeeDee Lamb, Jaylen Waddle, Nico Collins, Jake Bobo, Rashee Rice (IR)
                            </p>
                            <p>
                                <strong>TE:</strong> Chig Okonkwo, Dalton Schultz
                            </p>
                            <p><strong>D/ST:</strong> Dolphins, Bills</p>
                            <p><strong>K:</strong> Will Reichard</p>
                        </div>
                    </motion.section>
                </div>

                {/* Matchup grid below draft picks and team & stats */}
                <motion.section
                    className="matchup-grid card"
                    style={{ marginTop: "2rem", padding: "1rem" }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.5 }}
                >
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(9, 1fr)",  // 9 columns equal width
                            gridAutoRows: "auto",
                            gap: "0.5rem",
                            width: "100%", // full width of parent container
                        }}
                    >
                        {matchups2024.map(({ opponent, pointsFor, pointsAgainst }, index) => {
                            const won = pointsFor > pointsAgainst;
                            const weekNumber = index + 1; // week number 1-18
                            return (
                                <div
                                    key={index}
                                    style={{
                                        backgroundColor: won ? "#d4edda" : "#f8d7da",
                                        border: `1px solid ${won ? "#155724" : "#721c24"}`,
                                        borderRadius: "6px",
                                        padding: "0.5rem",
                                        fontSize: "0.8rem",
                                        textAlign: "center",
                                        color: won ? "#155724" : "#721c24",
                                        userSelect: "none",
                                        minWidth: 0,
                                    }}
                                >
                                    <div>Week {weekNumber}:</div>
                                    <div>vs. {opponent}</div>
                                    <div>
                                        {pointsFor} - {pointsAgainst}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </motion.section>
            </main>

            {/* Footer */}
            <footer className="footer">Created by Nick Criss ⚡️</footer>
        </div>
    );
};

export default ChrisBode;
